import request from '@/services/index';
import LoginRequest from '@/services/loginRequest';

// 登录初始化
export const initializeInfo = () => {
  return request.post(`/api/group/initialize`);
};

// 登录
export const login = (data) => {
  return LoginRequest.post(`/sso/admin/login`,data);
};

// 注册
export const reg = (data) => {
  return LoginRequest.post(`/sso/admin/register`, data);
};

// 获取用户 信息
export const getUserInfo = () => {
  return LoginRequest.get(`/sso/admin/info`);
};

// 退出登录
export const outLogin = () => {
  return LoginRequest.post(`/sso/admin/logout`);
};

/**
 * 发送验证码
 * @return {Promise<*|undefined>}
 * @param data { phone, code, key, token, sceneCode }
 */
export const sendCode = (data) => {
  const params = {...data};
  if (import.meta.env.VITE_LANG === 'en') {
    params['email'] = data.phone;
    delete params['phone'];
  }

  return LoginRequest.post(`/sso/admin/sendCode`, params);
};

/**
 * 获取图片验证码
 * @param key {string} 浏览器指纹生成的硬件唯一值
 * @return {Promise<*|undefined>}
 */
export const getCaptcha = (key) => {
  return LoginRequest.get(`/sso/captcha?key=${key}`, null, {
    responseType: 'blob' // 图片返回blob格式
  });
};

/**
 * 更新密码
 * @param data { code, password }
 * @return {Promise<any|undefined>}
 */
export const updatePassword = (data) => {
  return LoginRequest.put(`/sso/admin/password/reset`, data);
};

/**
 * 获取 群 二维码
 * */
export const getGroupQr = () => {
  return request.get(`/api/share/qun`);
};

/**
 * 获取 客户 二维码
 * */
export const getClientQr = () => {
  return request.get(`/api/share/kefu`);
};

/**
 * 获取OSS凭证
 */
export const getOssToken = () => {
  return request.post('/api/oss/getToken');
};

/**
 * 获取图片下载链接
 * @param {Array} imageList - 图片路径数组
 * @param {Array} originNames - 原始文件名数组（可选）
 * @param {Boolean} originalImage - 是否返回原图，默认true
 * @param {String} process - 图片处理参数（可选）
 */
export const getImageDownloadUrls = (imageList, originNames = null, originalImage = true, process = null) => {
  return request.post('/api/oss/download', {
    imageList,
    originNames,
    originalImage,
    process
  });
};

/**
 * 获取单个图片的重定向URL
 * @param {String} url - 图片路径
 * @param {Boolean} originalImage - 是否返回原图，默认true
 * @param {String} process - 图片处理参数（可选）
 */
export const getImageRedirectUrl = (url, originalImage = true, process = null) => {
  // 使用相对路径，让代理处理
  const baseUrl = '/api/oss/downloadImage';
  const params = new URLSearchParams({
    url: url,
    originalImage: originalImage.toString()
  });
  
  if (process) {
    params.append('process', process);
  }
  
  return `${baseUrl}?${params.toString()}`;
};